import React, { Component } from 'react';
import { useNavigate } from "react-router-dom";
import {Row, Col, Card, Button, Modal, Form} from 'react-bootstrap';
import axios from 'axios';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import "flag-icons/css/flag-icons.min.css";
import ShareObject from './sharejob';

import SplitPane from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';

const defaultColDef = {
    filter: true,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
    menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
    filterParams: {
      buttons: ["reset"],
      closeOnApply: true,
    },
};

const autoGroupColumnDef = {
  pinned: 'left', // Pin the group column to the left
}

const defaultSideBar = {
  toolPanels: [
    {
      id: 'filters',
      labelDefault: 'Filters',
      labelKey: 'filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
      toolPanelParams: {
        suppressExpandAll: true,
        suppressFilterSearch: true,
      }
    },
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'column',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressExpandAll: true,
        suppressFilterSearch: true,
      },
    },
  ],
};
const rowSelection = 'single';
const rowGroupPanelShow = 'onlyWhenGrouping';

const rowModelType = 'serverSide';
const cacheBlockSize = 100;

const listBackgrounds = ['#000','#28749e','#2b908f','#d7890f'];
const listIcons = ['bi-card-list', 'bi-buildings', 'bi-people', 'bi-card-checklist'];

class Lists extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isGridView: false,
            gridApi: null,
            rowData: [],
            columnDefs: [],
            selectedData: [],
            selectedId: 0,
            updatingRowData: false,
            gsplit: [`0%`, 'auto'],
            cards: [],
            selectedCard: 0,
            lastVisibleCard: 0,
            filterMode: 0,
            isEditModalOpen: false,
            isShareModalOpen : false,
            listName: '',
          }

        this.tableRefs = [];
        this.onGridReady = this.onGridReady.bind(this);
        this.getRows = this.getRows.bind(this);
        this.getChildCount = this.getChildCount.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.onModelUpdated = this.onModelUpdated.bind(this);
        this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
        this.groupCountComparator = this.groupCountComparator.bind(this);
        this.onStoreRefreshed = this.onStoreRefreshed.bind(this);
        this.checkRenderer = this.checkRenderer.bind(this);
        this.statusRenderer = this.statusRenderer.bind(this);
        this.flagRenderer = this.flagRenderer.bind(this);
        this.tldRenderer = this.tldRenderer.bind(this);
        this.urlRenderer = this.urlRenderer.bind(this);
        this.toggleView = this.toggleView.bind(this);
        this.refreshCards = this.refreshCards.bind(this);
        this.cardSelectionChanged = this.cardSelectionChanged.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.handleCardsScroll = this.handleCardsScroll.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.closeEditModal = this.closeEditModal.bind(this);
        this.editList = this.editList.bind(this);
        this.deleteList = this.deleteList.bind(this);
        this.openShareModal = this.openShareModal.bind(this);
        this.closeShareModal = this.closeShareModal.bind(this);
        this.switchToList = this.switchToList.bind(this);
    };
 
    handleCardsScroll(e) {
      const cardsList = e.currentTarget;
      const top = (cardsList.scrollTop === 0);
      const bottom = (Math.abs(cardsList.scrollHeight - (cardsList.scrollTop + cardsList.clientHeight)) <= 5);
      if (top) {
        // this.state.gridApi?.ensureIndexVisible(0, 'top')
      } else if (bottom) {
        const index = this.state.cards.length;
        this.state.gridApi?.ensureIndexVisible(index, 'bottom');
        const lastVisibleIndex = Math.max(0, index - 1);
        const lastVisibleCard = this.state.cards[lastVisibleIndex].id;
        this.setState({ lastVisibleCard: lastVisibleCard });
      } else {
        this.setState({ lastVisibleCard: 0 });
      }
    }

    checkRenderer (params) {
      return (<div className='d-flex justify-content-center'><i className={`${(params.value && params.value === 1) ? 'bi bi-file-check' : ''}`}></i></div>)
    };

    flagRenderer (params) {
      return ((params.value && params.value !== '') ? <div title={params.data ? params.data.countryname : ''} className={`fi fi-${params.value.toLowerCase()}`}></div> : '')
    }

    tldRenderer (params) {
      return ((params.value && params.value !== '') ? 
          <a rel="noreferrer" target='_blank' href={`https://${params.value}`}>{params.value}</a>
        : '' )
    }

    urlRenderer (params) {
      return ((params.value && params.value !== '') ? (
          <div className='d-flex justify-content-center mx-1'>
            <a rel="noreferrer" target='_blank' href={`${params.value}`}><i title={params.title} className={`${params.icon}`}></i></a>
          </div> 
        ) : '' )
    }

    statusRenderer (params) {
      return (<div className='mx-auto' style={{width: '18px', height:'18px'}}><i title={`Site Scan ${(params.value === 1) ? 'Completed' : 'Pending'}`} className={`bi ${(params.value === 1) ? 'bi-check-circle-fill' : 'bi-circle-half'} text-dark`}></i></div>)
    }

    fetchData = async() => {
      if (!this.state.updatingRowData) {
        this.setState({ updatingRowData: true });
        this.props.urd(true);

        this.state.gridApi?.refreshServerSide({purge: false});
      }
    }

    // Custom comparator function to sort groups by group counts
    groupCountComparator(valueA, valueB, nodeA, nodeB, isInverted) {
      // Get the group counts for the two groups
      const countA = nodeA ? nodeA.allChildrenCount : valueA; // Number of children in group A
      const countB = nodeB ? nodeB.allChildrenCount : valueB; // Number of children in group B

      // Compare the counts and return the result
      if (countA < countB) {
        return -1;
      } else if (countA > countB) {
        return 1;
      } else {
        return 0;
      }
    }

    onGridReady(params) {
        this.setState({
            gridApi: params.api,
        })
        params.api.setServerSideDatasource({getRows: this.getRows});
      }

    getRows(params) {
      const serverURL = `/api/getaglists/${this.props.uid}`;
      
      this.setState({ updatingRowData: true });
      this.props.urd(true);
      fetch(serverURL, {
        method: 'post',
        body: JSON.stringify(params.request),
        headers: { "Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}`}
      })
      .then(httpResponse => httpResponse.json())
      .then(response => {
        params.successCallback(response.rows, response.lastRow);
        this.setState({ updatingRowData: false });
        this.props.urd(false);
      })
      .catch(error => {
        console.error(error);
        params.failCallback();
      })
    }

    getChildCount(data) {
      return data ? data.childCount : undefined
    }
    
    onSelectionChanged() {
      if (this.state.isGridView) {
        const data = this.state.gridApi.getSelectedRows();
        this.setState({
            selectedData: data,
            selectedId: data.id,
            listName: data.name,
        })
        this.props.slu(data.id);

        const index = Math.max(this.state.cards.findIndex(row => (row.id === data.id)), 0);
        this.cardSelectionChanged(index);
      }
    }

    onModelUpdated = (params) => {
      this.setState({ updatingRowData: false });
      this.props.urd(false);
      this.refreshCards();
    }

    onStoreRefreshed = (params) => {
      this.setState({ updatingRowData: false });
      this.props.urd(false);
    }

    onFirstDataRendered = (params) => {
      var cols = [
        { field: 'id', headerName: 'Id', filter: 'agNumberColumnFilter', cellStyle: {textAlign: 'center'} },
        { field: 'name', headerName: 'Name', filter: 'agTextColumnFilter', width: 150, comparator: this.groupCountComparator},
        { field: 'typetext', headerName: 'Type', filter: 'agNumberColumnFilter', cellStyle: {textAlign: 'center'} },
        { field: 'u_name_email', headerName: 'Owner', filter: 'agTextColumnFilter' },
      ];
      this.setState({columnDefs: cols})
    }

    toggleView(currentView) {
      this.setState({
        isGridView: currentView,
        gsplit: currentView ? ["100%", 'auto'] : ["0%", 'auto']
      })
      this.refreshCards();
    }

    refreshCards() {
      var cards = [];
      this.state.gridApi && this.state.gridApi.forEachNode((node, index) => {if ((!node.group) && (node.data)) cards.push(node.data)});
      if (cards.length > 0) {
        this.setState({cards: cards});
      }
      
      if (cards.length > 0) { 
        const selCard = Math.max(cards.findIndex(row => (row.id === this.state.selectedId)), 0);
        const selData = cards[selCard];
        this.setState({
          selectedCard: selCard,
          selectedData: selData,
          selectedId: selData.id
        });
        this.props.slu(selData.id);
      }

      setTimeout(() => {
        const card = document.getElementById(`lead-${this.state.lastVisibleCard}`);
        card?.scrollIntoView(false);
      }, 50)
    }
    
    cardSelectionChanged(rowid) {
      const data = this.state.cards[rowid];
      this.setState({
        selectedData: data,
        selectedId: data.id,
        listName: data.name,
        selectedCard: rowid,
        lastVisibleCard: rowid,
      })
      this.props.slu(data.id);
    }

    applyFilter(filterValues) {
      this.state.gridApi && this.state.gridApi.setFilterModel(filterValues);
      if (!this.state.isGridView) this.refreshCards();
    }

    openEditModal() {
      this.setState({ isEditModalOpen: true })
    }

    closeEditModal() {
      this.setState({ isEditModalOpen: false })
    }

    editList(e) {
      const request = {
        url: '/editlist',
        method: 'POST',
        data: {id: this.state.selectedId, name: this.state.listName},
      }

      axios(request)
      .then((res) => {
        this.props.pfr();
        // console.log(res);
      })
      .catch((err) => {
        console.log(err)
      })
      this.closeEditModal();
    }

    deleteList(e) {

      const listId = e.currentTarget.dataset.listid;
      const request = {
        url: '/deletelist',
        method: 'POST',
        data: {id: listId},
      }
      if(window.confirm('Are you sure you want to delete this list?'))
      {
        axios(request)
        .then((res) => {
          this.props.pfr();
          this.fetchData();
          // console.log(res);
        })
        .catch((err) => {
          console.log(err)
        })
      }
    }
  
    openShareModal() {
      this.setState({ isShareModalOpen: true })
    }
  
    closeShareModal() {
      this.setState({ isShareModalOpen: false })
    }

    switchToList (e) {
      const eListId = e.currentTarget.dataset.id;
      const eListType = parseInt(e.currentTarget.dataset.type);
      const { navigate } = this.props;
      
      if(eListType===1)
        navigate(`/mmain/businesses`, {state: { listId: eListId}})
      else if(eListType===2)
        navigate(`/mmain/people`, {state: { listId: eListId}})
    }
  
    render () {
      const getFiltersFromGridState = (state) => {
        var oFilters = {};
        try {
          const oState = JSON.parse(state);
          oFilters = {
            "#Leads": (parseInt(oState.resultsCount) > 0) ? parseInt(oState.resultsCount).toLocaleString() : '',
            "Category Group Type": oState.filterCategoryGroup ? oState.filterIsUserCategoryGroup ? 'User Defined' : 'System' : '',
            "Category Group": (oState.filterCategoryGroup?.length > 0) ? oState.filterCategoryGroup.label : '',
            "Multiple Categories": (oState.filterMultipleCategories?.length > 0) ? oState.filterMultipleCategories : '',
            "Category": (oState.filterCategory?.length > 0) ? oState.filterCategory : '',
            "Country": oState.filterCountry,
            "State": oState.filterState,
            "Hidden Gems": oState.filterKeywords,
          };
          Object.entries(oState.filterModel).map(([key, value]) => {
            const filterHeader = oState.columnDefs.filter(o => o.field === key)[0].headerName;
            var filterValue = '';
            if (value.filterType === 'set') {
              filterValue = value.values
            } else if (value.type === 'inRange') {
              filterValue = `${value.filter} - ${value.filterTo}`
            } else if (value.filter) {
              filterValue = value.filter
            } 
          
            oFilters[filterHeader] = filterValue;
          })
        } catch (err) {
          // do something
        } finally {
          return oFilters
        }
      }
      
    return (
      <React.Fragment>
        <SplitPane split="horizontal" allowResize={false} sizes={this.state.gsplit} resizerSize={5} onChange={(data) => this.setState({gsplit: data})}>
          <div className="ag-theme-balham" style={{height: '100%'}}>
            <AgGridReact 
              columnDefs={this.state.columnDefs}
              defaultColDef={defaultColDef}
              autoGroupColumnDef={autoGroupColumnDef}
              sideBar={defaultSideBar}
              suppressContextMenu={true}
              animateRows={true}
              rowMultiSelectWithClick={false}
              rowSelection={rowSelection}
              rowGroupPanelShow={rowGroupPanelShow}
              onGridReady={this.onGridReady}
              onGridRefresh={this.onGridRefresh}
              onSelectionChanged={this.onSelectionChanged}
              onRowDataUpdated={this.onRowDataUpdated}
              onModelUpdated={this.onModelUpdated}
              onFirstDataRendered={this.onFirstDataRendered}
              onStoreRefreshed={this.onStoreRefreshed}
              rowModelType={rowModelType}
              getChildCount={this.getChildCount}
              cacheBlockSize={cacheBlockSize}
              alwaysShowHorizontalScroll={false}
              alwaysShowVerticalScroll={false}
            ></AgGridReact>
          </div>
        {this.state.cards ? (
        <div  className="m-2" style={{maxHeight: "99%", display: 'grid', overflowX: 'hidden', overflowY: 'auto', gap: '4px', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))'}}onScroll={this.handleCardsScroll}>
          <div className={`w-100 justify-content-center ${((this.state.updatingRowData) || (this.state.cards.length > 0)) ? 'd-none' : 'd-flex'}`}>
            <p style={{fontFamily: "var(--font-family-sans-serif)"}}>
                There's nothing here, yet.
            </p>
          </div>
          {this.state.cards.map((row, index) => { this.tableRefs[index] = React.createRef(); return (
          <Col xs={2} className='m-1 mb-4' style={{width: '100%', boxSizing: 'border-box'}}>
            <Card 
              id={`list-${row.id}`}
              key={index} 
              onClick={() => this.cardSelectionChanged(index)}
              className={`m-1 p-0 text-primary border border-2 ${(index === this.state.selectedCard) ? 'border-primary shadow-lg' : 'shadow'}`} 
            >
              <Card.Header className={`p-1 fs-6 text-white`} style={{backgroundColor: `${listBackgrounds[row.type]}`}}>
                <div className="d-flex flex-row">
                  <div title={row.name} className="p-2 h6 my-auto text-white text-truncate" style={{textWrap: "nowrap"}}>
                <i className={`mx-1 bi ${listIcons[row.type]}`}></i>{row.name}
                  </div>
                  <div className="ms-auto my-auto">
                    <Button id={`btn-${row.id}`} data-id={row.id} data-type={row.type} title="Switch to Leads" size="sm" className={`me-1 shadow`} style={{backgroundColor: "transparent", borderColor: "transparent"}} onClick={this.switchToList}>
                      <i className="text-white bi bi-folder-symlink"></i>
                    </Button>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className='p-2 d-flex align-content-end flex-column' style={{backgroundColor: `${listBackgrounds[row.type]}11`}}>
                <Card.Text className={`text-dark`} style={{overflow: "auto", maxHeight: "200px"}}>
                  {row.type === 3 ? (
                    <Row className='m-0 p-0 my-1 py-1' style={{backgroundColor: `${listBackgrounds[row.type]}22`}}>
                      <Col className='fw-bold' xs={6}>#Leads</Col>
                      <Col className="text-truncate">
                        {(() => {
                          try {
                            const stateObj = JSON.parse(row.state);
                            return stateObj.resultsCount ? parseInt(stateObj.resultsCount).toLocaleString() : 0;
                          } catch (e) {
                            return 0;
                          }
                        })()}
                      </Col>
                    </Row>
                  ) : (
                    <>
                      {Object.entries(getFiltersFromGridState(row.state)).map(([key, value]) => {return (value === '' || value === undefined) ? '' : (
                        <Row key={key} className='m-0 p-0 my-1 py-1' style={{backgroundColor: `${listBackgrounds[row.type]}22`}}>
                          <Col className='fw-bold' xs={6}>{key}</Col><Col className="text-truncate" title={value}>{value}</Col>
                        </Row>
                      )})}
                      {row.selectedids && row.selectedids.length > 0 && (
                        <Row className="m-0 p-0 my-1 py-1" style={{ backgroundColor: `${listBackgrounds[row.type]}22` }}>
                          <Col className="fw-bold" xs={6}>Selected IDs</Col>
                          <Col className="text-truncate" title={row.selectedids}>
                            {row.selectedids.length > 12 ? `${row.selectedids.slice(0, 12)}...` : row.selectedids}
                          </Col>
                        </Row>
                      )}
                    </>
                  )}
                </Card.Text>
                <Card.Text className="d-flex">
                  <Button data-id={index} title="Edit" className="me-1 border border-gray" style={{ borderRadius: "50%" }} variant="outline-primary" onClick={this.openEditModal}><i className="bi bi-pencil-square"></i></Button>
                  {(row.ownerid === row.userid) ? (
                  <Button data-id={index} title="Share" className="me-1 border border-gray" style={{ borderRadius: "50%" }} variant="outline-primary" onClick={this.openShareModal}><i className="bi bi-share"></i></Button>
                  ) : ''}
                  {(row.ownerid === row.userid) ? (
                  <Button data-id={index} data-listid={row.id}  title="Delete" className="ms-auto border border-gray" style={{ borderRadius: "50%" }} variant="outline-primary" onClick={this.deleteList}><i className="bi bi-trash"></i></Button>
                  ) : (
                  <Button data-id={index} title={`Shared by ${row.u_name_email}`} className="ms-auto border-0" style={{borderRadius: "50%"}} variant="outline-primary"><i className="bi bi-people-fill"></i></Button>
                  )}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          )})}
        </div>
          ) : <></>}
      </SplitPane>
      <ShareObject isOpen={this.state.isShareModalOpen} onClose={this.closeShareModal} objType="list" objId={this.state.selectedId} loggedInUserId={this.props.uid} />
      <Modal show={this.state.isEditModalOpen} onHide={this.closeEditModal} centered>
        <Modal.Body className='p-2 shadow'>
          <div className='d-flex flex-column'>
            <Form.Group className="m-3">
              <Form.Label className='fs-6 fw-bold'>Edit List Name</Form.Label>
              <Form.Control
                type='text'
                defaultValue={this.state.listName}
                placeholder='List Name'
                autoFocus
                onChange={(e) => this.setState({listName: e.target.value})}
              />
            </Form.Group>
          </div>
          <div className='p-2 d-flex justify-content-end'>
            <Button className='mx-1' variant="secondary" onClick={this.closeEditModal}>
              Cancel
            </Button>
            <Button className={`mx-1 ${(this.state.listName === '') ? 'disabled' : ''}`} variant="primary" onClick={this.editList}>
              Save
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      </React.Fragment>
    )}
}

export default function(props) {
  const navigate = useNavigate();

  return <Lists {...props} navigate={navigate} />;
}
